import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const InvoiceLogs = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, showOnMobile: true },
			{
				Header: 'provider',
				accessor: 'provider',
				filterType: FilterType.string
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'clientID',
				accessor: 'clientId',
				filterType: FilterType.number
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				filterRemovable: false
			},
			{
				Header: 'paymentID',
				accessor: 'paymentID',
				filterType: FilterType.number
			},

			{
				Header: 'response',
				accessor: 'response',
				filterType: FilterType.string
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'companyID',
				accessor: 'companyId',
				filterType: FilterType.number,
				showOnMobile: true
			},

			{
				Header: 'attemptDate',
				accessor: 'attemptDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},

			{
				Header: 'requestJSON',
				accessor: 'payload',
				filterType: FilterType.string,
				width: 100,
				showCopyButton: true
			},
			{
				Header: 'transactionAmount',
				accessor: 'transactionAmount',
				filterType: FilterType.number
			},
			{
				Header: 'transactionId',
				accessor: 'transactionId',
				filterType: FilterType.number
			},
			{
				Header: 'transactionType',
				accessor: 'transactionType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.INVOICE_LOGS_TRANSACTION_TYPE
			},
			{ Header: 'invoiceID', accessor: 'invoiceId', filterType: FilterType.number, showCopyButton: true },
			{
				Header: 'invoiceNumber',
				accessor: 'invoiceNumber',
				filterType: FilterType.number
			},
			{
				Header: 'invoiceCreated',
				accessor: 'invoiceCreated',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO
			},
			{
				Header: 'reported',
				accessor: 'reported',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.INVOICE_LOGS_STATUS
			},
			{
				Header: 'endpointUrl',
				accessor: 'endpointUrl',
				filterType: FilterType.string
			}
		],
		[]
	);

	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((c) => c.accessor === 'transactionDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(29, 'day').startOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[columns]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.INVOICE_LOGS}
				columns={columns}
				fetchUrl={FINANCE.GET_INVOICE_LOGS}
				defaultFilters={defaultFilters}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="invoiceLogs"
				infiniteScroll
			/>
		</TabTableContainer>
	);
};

export default InvoiceLogs;
